import React, { createContext, useState } from 'react';
import { DEFAULT_REGION } from './lib/constants';

/**
 * Default value for region in RegionContext
 * @type {{labelTag: string, iconName: string, label: string, value: string}}
 */
const DefaultRegionValue = {
    label: DEFAULT_REGION.regionName,
    value: DEFAULT_REGION.regionName,
    labelTag: DEFAULT_REGION.regionTag,
    iconName: 'settings',
};

/**
 * Custom context for user selected region
 * @type {React.Context<{labelTag: string, iconName: string, label: string, value: string}>}
 */
export const RegionContext = createContext(DefaultRegionValue);

export const RegionContextProvider = ({ children }) => {
    const [selectedRegion, setSelectedRegion] = useState(DefaultRegionValue);
    return <RegionContext.Provider value={{ selectedRegion, setSelectedRegion }}>{children}</RegionContext.Provider>;
};
